import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: []
})
export class ConfirmDialogComponent implements OnInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: { title: string, content: string, cancelBtn: string, okBtn: string },
        public dialogRef: MatDialogRef<ConfirmDialogComponent>
    ) {
    }

    ngOnInit() {
    }

    onCancel() {
        this.dialogRef.close(false);
    }

    onSuccess() {
        this.dialogRef.close(true);
    }

}
